import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

export default function AdminMembersTab() {
  const [members, setMembers] = useState([]);
  const [q, setQ] = useState("");
  const load = async () => {
    try { const { data } = await api.get("/admin/members", { params: { q } }); setMembers(data); }
    catch (e) { toast.error(fmtErr(e)); }
  };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q]);

  const toggle = async (m) => {
    try {
      await api.patch(`/admin/members/${m.user_id}`, { active: !m.active });
      toast.success(m.active ? "Member deactivated" : "Member activated");
      load();
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div data-testid="admin-members">
      <div className="flex items-center gap-2 bg-zinc-950 border border-zinc-700 px-3 mb-5 max-w-xl">
        <Search size={15} className="text-zinc-500" />
        <input data-testid="admin-member-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search members…"
          className="w-full bg-transparent py-3 text-sm focus:outline-none placeholder-zinc-600" />
      </div>
      <div className="border border-zinc-800 divide-y divide-zinc-800/70">
        {members.map((m) => (
          <div key={m.user_id} data-testid={`admin-member-${m.user_id}`} className="bg-zinc-950 p-4 flex flex-wrap items-center justify-between gap-4">
            <div>
              <p className="font-bold text-zinc-100">{m.name} <span className={`ml-2 text-[9px] uppercase tracking-[0.14em] px-2 py-1 ${m.active ? "bg-volt text-black" : "bg-zinc-800 text-zinc-500"}`}>{m.active ? "Active" : "Inactive"}</span></p>
              <p className="text-xs text-zinc-500">{m.email}{m.phone ? ` · ${m.phone}` : ""}</p>
            </div>
            <div className="flex items-center gap-4">
              <p className="text-[10px] uppercase tracking-[0.14em] text-zinc-500">{m.credential_issued ? "Password set" : "Setup pending"}</p>
              <button data-testid={`admin-member-toggle-${m.user_id}`} onClick={() => toggle(m)}
                className="border border-zinc-700 px-4 py-2 text-[10px] uppercase tracking-[0.14em] font-bold hover:border-volt hover:text-volt transition-colors">
                {m.active ? "Deactivate" : "Activate"}
              </button>
            </div>
          </div>
        ))}
        {!members.length && <p className="p-5 text-sm text-zinc-600">No members found.</p>}
      </div>
    </div>
  );
}
